import React, {Component} from 'react'
import {Select} from 'antd'
import withUrlFetch from '../withUrlFetch'
import {compose} from 'recompose'
import withSpinning from '../../HOC/withSpinning'
import withSort from '../../HOC/withSort'
import CustomSelect from '../../../elements/Select/CustomSelect'

const Option = Select.Option

class Requisitions extends Component {
  render() {
    const {placeholder, data} = this.props
    return (
      <CustomSelect
        placeholder={placeholder || 'Select an Requisitions'}
        {...this.props}>
        {data.map(t => (
          <Option value={t._id}>{`${t.code} - ${t.name}`}</Option>
        ))}
      </CustomSelect>
    )
  }
}

Requisitions.propTypes = {}
Requisitions.defaultProps = {}

const RequisitionsSelect = compose(
  withUrlFetch({name: 'labourRequisitions', url: 'labourreqs/', cache: false}),
  withSpinning,
  withSort,
)(Requisitions)

export default RequisitionsSelect
